export default "__VITE_ASSET__B$mLOH5R__"